import { authHeader, isTokenExpired } from "../helpers";

export const categoryService = {
  fetchCategories,
  categoryNameExist,
  createCategory,
  deleteCategory,
  fetchTags,
  updateCategory,
};

function fetchCategories() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${process.env.REACT_APP_GATEWAY_URL}/category`, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchTags() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${process.env.REACT_APP_GATEWAY_URL}/tags`, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateCategory(
  category,
  logo,
  image,
  errorToast,
  successToast,
  unlockForm,
  closeModal,
  resetLoader
) {
  const formData = new FormData();

  if (logo)
    formData.append("logo", logo[0], logo[0].name.replaceAll(/\s/g, ""));
  if (image)
    formData.append("image", image[0], image[0].name.replaceAll(/\s/g, ""));
  formData.append("category", JSON.stringify(category));

  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: formData,
  };

  const url = process.env.REACT_APP_GATEWAY_URL + `/category`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        successToast();
        unlockForm();
        closeModal();
        resetLoader();
        return Promise.resolve();
      } else {
        errorToast();
        unlockForm();
        resetLoader();
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function categoryNameExist(name) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/category/${name}/exists`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function createCategory(name, logo, image, errorToast, successToast) {
  const formData = new FormData();

  formData.append("logo", logo[0], logo[0].name.replaceAll(/\s/g, ""));
  formData.append("image", image[0], image[0].name.replaceAll(/\s/g, ""));
  formData.append("category", JSON.stringify({ name }));

  const requestOptions = {
    method: "POST",
    headers: authHeader(true),
    body: formData,
  };

  const url = process.env.REACT_APP_GATEWAY_URL + `/category`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        successToast();
        return Promise.resolve();
      } else {
        errorToast();
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function deleteCategory(id, toastSuccess, toastError, refreshCategories) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/category/${id}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        toastSuccess();
        refreshCategories();
        return res;
      } else {
        toastError();
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}
